import { NavLink } from 'react-router-dom';
import styles from './index.module.css';

/**
 * Overview and Interviewer, for a job. Rendered only with the interviewer
 * setup on; with it off the job page has no tabs, as before.
 */
const JobTabs = ({ jobId }: { jobId: string | number }) => (
  <nav className={styles.tabs} aria-label="Job sections">
    <NavLink
      to={`/jobs/${jobId}`}
      end
      className={({ isActive }) =>
        `${styles.tab} ${isActive ? styles.active : ''}`
      }
    >
      Overview
    </NavLink>
    <NavLink
      to={`/jobs/${jobId}/interviewer`}
      className={({ isActive }) =>
        `${styles.tab} ${isActive ? styles.active : ''}`
      }
    >
      Interviewer
    </NavLink>
  </nav>
);

export default JobTabs;
